import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders, HttpParams } from "@angular/common/http";
import { Observable } from "rxjs";

// Import Model
import { GetUserModel, UserListIndexModel, UserlistModel } from "../../../model/builk/user-manager/get-users";
import { CompanyManagelistModel } from "../../../model/builk/company-manage/company-list";
import { apiLink } from "../../../constant/api-link";
import { ResetPasswordModel } from '../../../model/builk/user-manager/reset-password.model';
import { ChangeUserStatusModel } from "../../../model/builk/user-manager/change-user-status.model";

@Injectable({
    providedIn: "root"
})
export class UserManagerService {

    constructor(
        private http: HttpClient
    ) { }

    sub: any;

    // get userlist (sort,search,filter)
    getAllUserBackOffice(getuser: GetUserModel): Observable<UserListIndexModel> {

        const url = apiLink.getUserListBuilk;
        const headers = new HttpHeaders({ "Content-Type": "application/json" });

        return this.http.post<UserListIndexModel>(url, getuser, { headers });
    }

    getReferralCodeSelector(): Observable<string[]> {
        const url = apiLink.getReferralCodeSelector;
        const headers = new HttpHeaders({ "Content-Type": "application/json" });
        return this.http.get<string[]>(url, { headers });
    }

    updateEmailActiveStatus(userEmail: string): Observable<boolean> {
        const url = apiLink.updateEmailActiveStatus;
        const params = new HttpParams().set("userEmail", userEmail);
        this.sub = this.http.get(url, { params });

        return this.sub;
    }

    updateStatusEmailLock(userList: UserlistModel): Observable<string> {
        const url = apiLink.updateStatusEmailLock;

        const headers = new HttpHeaders({ "Content-Type": "text/json" });

        return this.http.put<string>(url, userList, { headers });
    }

    getUserCompanyList(userSurrKey: number): Observable<CompanyManagelistModel> {

        const url = apiLink.getUserCompanyList;

        const params = new HttpParams()
            .set("userSurrKey", userSurrKey.toString());

        this.sub = this.http.get(url, { params });

        return this.sub;
    }

    updateCommentBackOffice(userList: UserlistModel): Observable<boolean> {
        const url = apiLink.updateCommentBackOffice;
        console.log(userList);
        console.log(url);

        const headers = new HttpHeaders({ "Content-Type": "text/json" });

        return this.http.put<boolean>(url, userList, { headers });
    }

    checkUserEmail(userEmail: string): Observable<string> {
        const url = apiLink.checkEmailLock;
        const params = new HttpParams().set("userEmail", userEmail);
        this.sub = this.http.get(url, { params });

        return this.sub;
    }

    resetPassword(resetPasswordModel: ResetPasswordModel): Observable<boolean> {
        const url = apiLink.resetPasswordCognito;
        const headers = new HttpHeaders({
            "Content-Type": "text/json"
        });
        this.sub = this.http.post<boolean>(url, resetPasswordModel, { headers });

        return this.sub;
    }

    exportUserListBuilk(query: GetUserModel): Observable<Blob> {
      const url = apiLink.exportUserListBuilk;

      let body = {
        // limit: query.limit,
        // page: query.page,
        sorttype: query.sorttype,
        sortcol: query.sortcol,
        usernamesearch: query.usernamesearch,
        companynamesearch: query.companynamesearch,
        phonenumbersearch: query.phonenumbersearch,
        provincesearch: query.provincesearch,
        countrysearch: query.countrysearch,
        userInactiveStatus: query.userInactiveStatus,
        referralCode: query.referralCode
      };
      if (query.startDate !== undefined && query.startDate !== null) {
        body['startDate'] = query.startDate.toISOString();
      }

      if (query.endDate !== undefined && query.endDate !== null) {
        body['endDate'] = query.endDate.toISOString();
      }
      const headers = new HttpHeaders({ "Content-Type": "application/json" });
      return this.http.post<Blob>(url, body, { responseType: 'blob' as 'json', headers: headers });
    }

    changeUserStatus(changeUserStatusModel: ChangeUserStatusModel): Observable<boolean> {
        const url = apiLink.changeUserStatus;
        const headers = new HttpHeaders({ "Content-Type": "application/json" });

        return this.http.post<boolean>(url, changeUserStatusModel, { headers });
    }
}
